import { render, staticRenderFns } from "./jsonEditor.vue?vue&type=template&id=45886d7c&scoped=true&"
import script from "./jsonEditor.vue?vue&type=script&lang=js&"
export * from "./jsonEditor.vue?vue&type=script&lang=js&"
import style0 from "./jsonEditor.vue?vue&type=style&index=0&id=45886d7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45886d7c",
  null
  
)

export default component.exports